export default "__VITE_ASSET__ee68188e__"